module.exports = __webpack_public_path__ + "assets/img/back-3.a217076e.png";